import React, { useContext } from 'react';
import MessageInput from './MessageInput/MessageInput';
import TemplatesPopupMenu from './Templates/TemplatesPopupMenu';
import SaveMessageAsTemplate from './Templates/SaveMessageAsTemplate';
import MessageInputProvider, {
  MessageInputContext,
} from './MessageInput/MessageInputContext';
import inboxService from 'venuescanner-js/react/components/Inbox/services/inboxService';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import IconPaperPlane from 'venuescanner-js/react/components/Objects/Icons/IconPaperPlane';
import IconButton from './Templates/IconButton';

const ChatReplyMessageInputComponent = ({ isHost }) => {
  const { clear, messageInputText, attached, loadMessage } =
    useContext(MessageInputContext);
  const { isUserTyping, activeThread, isMobileDevice } =
    useContext(ViewContext);
  const handleSubmit = () => {
    if (messageInputText.current.innerHTML !== '' || attached.length > 0) {
      sendMessage({ message: messageInputText.current.innerHTML });
      clear();
    }
  };

  const sendMessage = ({ message }) => {
    return inboxService.replyThread({
      _id: activeThread.data()._id,
      message,
      attachments: attached,
    });
  };

  const buildTemplate = () => {
    return {
      name: window.prompt(
        [
          'Please enter the template name',
          '',
          'This will be the name that appears in the short list',
          '',
          'The content of the current message box will be saved to be reused later as a template',
        ].join('\n'),
      ),
      content: messageInputText.current.innerText,
      attachments: attached,
    };
  };
  return (
    <>
      <MessageInput
        inboxMaxHeight='16rem'
        actionTriggers={
          <>
            {isHost && (
              <TemplatesPopupMenu
                onTemplateSelected={template => {
                  loadMessage(template);
                }}
              />
            )}
            {isHost && !isMobileDevice && (
              <SaveMessageAsTemplate buildTemplate={buildTemplate} />
            )}
            {isUserTyping && (
              <IconButton
                onClick={handleSubmit}
                icon={<IconPaperPlane />}
                text=''
                style={{
                  position: 'absolute',
                  right: '0',
                }}
              />
            )}
          </>
        }
      />
    </>
  );
};

const ChatReplyMessageInput = ({ isHost }) => (
  <MessageInputProvider>
    <ChatReplyMessageInputComponent isHost={isHost} />
  </MessageInputProvider>
);

export default ChatReplyMessageInput;
